import { useEffect, useState } from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import CardMedia from '@mui/material/CardMedia'
import Container from '@mui/material/Container'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import Grid from '@mui/material/Grid'
import Link from '@mui/material/Link'
import Typography from '@mui/material/Typography'
import { NavLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

// ---------------------------------------------------------------------------
// Helper: list of gallery images (replace with your real URLs)
// ---------------------------------------------------------------------------
const GALLERY_IMAGES = [
  { src: '/images/gallery/01.jpg', altKey: 'gallery.alt1' },
  { src: '/images/gallery/02.jpg', altKey: 'gallery.alt2' },
  { src: '/images/gallery/03.jpg', altKey: 'gallery.alt3' },
  { src: '/images/gallery/04.jpg', altKey: 'gallery.alt4' },
  { src: '/images/gallery/05.jpg', altKey: 'gallery.alt5' }
  // add as many as you like
]

export default function Social () {
  const { t } = useTranslation('social')
  const [openImg, setOpenImg] = useState(null) // holds the image object for the dialog

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const handleOpen = (img) => () => setOpenImg(img)
  const handleClose = () => setOpenImg(null)

  return (
    <Container sx={{ mt: 8, mb: 4 }} maxWidth='xl'>
      {/* --------------------------------------------------- HERO */}
      <Box
        sx={{
          textAlign: 'center',
          mb: 6
        }}
      >
        <Typography variant='h3' component='h1' gutterBottom>
          Peaks Sports – Trail Runners DXB
        </Typography>

        <Typography variant='subtitle1' gutterBottom>
          {t('hero.subtitle')}
        </Typography>

        <Box
          sx={{
          mt: 2
        }}
        >
          <Button
            component={Link}
            href='https://www.instagram.com/trail_runners_dxb/'
            target='_blank'
            variant='contained'
            color='primary'
            sx={{ mr: 1 }}
          >
            {t('hero.followInstagram')}
          </Button>

          <Button
            component={Link}
            href='https://chat.whatsapp.com/your-whatsapp-invite-link'
            target='_blank'
            variant='contained'
            color='secondary'
            sx={{ mx: 1 }}
          >
            {t('hero.joinWhatsappGroup')}
          </Button>

          <Button
            component={NavLink}
            to='/volunteer'
            variant='contained'
            color='success'
            sx={{ ml: 1 }}
          >
            {t('hero.registerVolunteer')}
          </Button>
        </Box>
      </Box>

      {/* --------------------------------------------------- BLOG STORY */}
      <Box
        sx={{
        mb: 6
      }}
      >
        <Typography variant='h4' gutterBottom>
          {t('journey.title')}
        </Typography>

        <Typography paragraph>
          {t('journey.paragraph1')}
        </Typography>

        <Typography paragraph>
          {t('journey.paragraph2')}
        </Typography>

        <Typography paragraph>
          {t('journey.paragraph3')}
        </Typography>

        <Typography paragraph>
          {t('journey.paragraph4')}
        </Typography>

        <Typography paragraph>
          {t('journey.paragraph5')}
        </Typography>
      </Box>

      {/* --------------------------------------------------- T‑SHIRT SHOWCASE */}
      <Box
        sx={{
          textAlign: 'center',
          mb: 8
        }}
      >
        <Typography variant='h4' gutterBottom>
          {t('tshirt.title')}
        </Typography>

        <Card sx={{ maxWidth: 400, mx: 'auto' }}>
          <CardMedia
            component='img'
            image='/images/tshirt.jpg' // replace with your actual file
            alt={t('tshirt.alt')}
          />
          <CardContent>
            <Typography variant='body1'>
              {t('tshirt.description')}
            </Typography>

            <Button
              component={Link}
              href='/shop/tshirt' // adjust to your shop route
              variant='contained'
              color='primary'
              sx={{ mt: 2 }}
            >
              {t('tshirt.buyNow')}
            </Button>
          </CardContent>
        </Card>
      </Box>

      {/* --------------------------------------------------- GALLERY */}
      <Box
        sx={{
        mb: 6
      }}
      >
        <Typography variant='h4' gutterBottom>
          {t('gallery.title')}
        </Typography>

        <Grid container spacing={2}>
          {GALLERY_IMAGES.map((img, idx) => (
            <Grid item xs={12} sm={6} md={3} key={idx}>
              <Card onClick={handleOpen(img)} sx={{ cursor: 'pointer' }}>
                <CardMedia
                  component='img'
                  height='140'
                  image={img.src}
                  alt={t(img.altKey)}
                />
              </Card>
            </Grid>
          ))}
        </Grid>

        {/* Lightbox Dialog */}
        <Dialog open={!!openImg} onClose={handleClose} maxWidth='lg'>
          {openImg && (
            <DialogContent sx={{ p: 0, backgroundColor: '#000' }}>
              <Box
                component='img'
                src={openImg.src}
                alt={t(openImg.altKey)}
                sx={{
                  width: '100%',
                  height: 'auto',
                  maxHeight: '90vh',
                  objectFit: 'contain'
                }}
              />
            </DialogContent>
          )}
        </Dialog>
      </Box>

      {/* --------------------------------------------------- FOOTER */}
      <Box
        sx={{
          textAlign: 'center',
          pt: 4,
          borderTop: 1,
          borderColor: 'divider'
        }}
      >
        <Typography
          variant='body2' sx={{
          color: 'text.secondary'
        }}
        >
          {t('footerRights', { year: new Date().getFullYear() })}
        </Typography>
      </Box>
    </Container>
  )
}
